import { render, staticRenderFns } from "./BookingSignaturesPage.vue?vue&type=template&id=0338bbae&"
import script from "./BookingSignaturesPage.vue?vue&type=script&lang=js&"
export * from "./BookingSignaturesPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingSignaturesPage.vue?vue&type=style&index=0&id=0338bbae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports